import { useParams, useSearchParams } from "react-router-dom";
import StudentGraphs from "../components/RateStudent/StudentGraphs";
import StudentAbout from "../components/RateStudent/StudentAbout";
import PageContent from "../../../ui/partials/MainContent";
import { Container } from "@mui/material";
import { Tabs, Tab } from "@mui/material";
import { StudentClassesAndAttendances } from "../components/RateStudent/StudentClassesAndAttendances";
import StudentEvents from "../components/RateStudent/StudentEvents";
import { StudentLogons } from "../components/RateStudent/StudentLogons";
import { StudentEvaluationsAndAttempts } from "../components/RateStudent/StudentEvaluationsAndAttempts";
import { useStudentEnrollmentData } from "../api/getStudentEnrollmentData";
import { StudentTasks } from "../components/RateStudent/StudentTasks";
function DiaryStudentStats({}) {
  const { enrollmentId } = useParams();
  const enrollmentQ = useStudentEnrollmentData({ enrollmentId });
  const [searchParams, setSearchParams] = useSearchParams({
    tab: 0,
  });

  const handleTabChange = (e, newValue) => {
    setSearchParams((prev) => ({
      tab: numberToTabName[newValue],
    }));
  };
  const tabNameToNumber = {
    graficos: 0,
    avaliacoes: 1,
    tarefas: 2,
    logons: 3,
    eventos: 4,
    aulas: 5,
  };
  const numberToTabName = {
    0: "graficos",
    1: "avaliacoes",
    2: "tarefas",
    3: "logons",
    4: "eventos",
    5: "aulas",
  };
  const currentTabValue = tabNameToNumber[searchParams.get("tab")] || 0;

  return (
    <>
      <PageContent>
        <Container>
          <StudentAbout enrollmentId={enrollmentId} />
          <Tabs onChange={handleTabChange} value={currentTabValue}>
            <Tab label="Gráficos" id={0} />
            <Tab label="Avaliações" id={1} />
            <Tab label="Tarefas" id={2} />
            <Tab label="Logons" id={3} />
            <Tab label="Eventos" id={4} />
            <Tab label="Aulas" id={5} />
          </Tabs>
          {currentTabValue == 0 && (
            <StudentGraphs enrollmentId={enrollmentId} />
          )}
          {currentTabValue == 1 && (
            <StudentEvaluationsAndAttempts enrollmentId={enrollmentId} />
          )}
          {currentTabValue == 2 && (
            <StudentTasks
              enrollmentId={enrollmentId}
              studentId={enrollmentQ.data?.studentId?.id}
              courseId={enrollmentQ.data?.courseId}
            />
          )}
          {currentTabValue == 3 && (
            <StudentLogons
              studentId={enrollmentQ.data?.studentId.id}
              courseId={enrollmentQ.data?.courseId}
            />
          )}
          {currentTabValue == 4 && (
            <StudentEvents studentId={enrollmentQ.data?.studentId.id} />
          )}
          {currentTabValue == 5 && (
            <StudentClassesAndAttendances enrollmentId={enrollmentId} />
          )}
        </Container>
      </PageContent>
    </>
  );
}

export default DiaryStudentStats;
